import type { FunctionComponent } from 'react'
import React from 'react'

import type { CardedDynamicTableProps } from './CardedDynamicTable'
import { CardedDynamicTableWrapper } from './CardedDynamicTableWrapper'

export const CardedDynamicTableLoggedOut: FunctionComponent<CardedDynamicTableProps> = ({
  dynamicTableId = '',
  logInCTA,
  products,
  signUpCTA,
  title,
  trackingPrefix = 'spp',
}) => {
  return (
    <CardedDynamicTableWrapper
      dynamicTableId={dynamicTableId}
      logInCTA={logInCTA}
      products={products}
      signUpCTA={signUpCTA}
      title={title}
      trackingPrefix={trackingPrefix}
    />
  )
}
